import { ReactNode } from 'react';
import clsx from 'clsx';

interface OptionCardProps {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
}

export function OptionCard({
  selected,
  onClick,
  children,
  className = '',
}: OptionCardProps) {
  return (
    <button
      type="button"
      className={clsx('option-card', { selected }, className)}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

interface OptionCardContentProps {
  title: string;
  description?: string;
}

export function OptionCardContent({ title, description }: OptionCardContentProps) {
  return (
    <div>
      <div className="font-semibold text-lg">{title}</div>
      {description && (
        <div className="text-sm text-secondary mt-1">{description}</div>
      )}
    </div>
  );
}
